import type { ModalProps } from "ui/components/Modal";
import Modal from "ui/components/Modal";
import cx from "ui/cx";
import styles from "./BuilderModal.module.scss";

export default function BuilderModal({ className, ...props }: ModalProps) {
  return <Modal className={cx(styles.wrapper, className)} {...props} />;
}
